<!-- AutoHeightTextarea.vue -->
<template>
  <div
    class="auto-height-textarea-wrapper"
    :id="wrapperId"
  >
    <textarea
      ref="textareaRef"
      :value="modelValue"
      @focus="() => adjustHeight()"
      @input="onInput"
      :placeholder="placeholder"
      :class="disableAutoHeight ? '' : 'auto-height-textarea'"
      v-bind="$attrs"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: 'AutoHeightTextarea',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'ここに入力してください...',
    },
    disableAutoHeight: {
      type: Boolean,
      default: false,
    },
    minHeightPx: {
      type: Number,
      default: 60,
    },
    maxHeightPx: {
      type: Number,
      default: 300,
    },
  },
  computed: {
    uid() {
      return this._.uid
    },
    wrapperId() {
      return `auto-height-textarea-wrapper-${this.uid}`
    },
  },
  watch: {
    modelValue(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$nextTick(() => {
          this.adjustHeight()
        })
      }
    },
  },
  mounted() {
    this.adjustHeight()
  },
  methods: {
    adjustHeight() {
      if (this.disableAutoHeight) {
        return // do nothing if disableAutoHeight is true
      }
      const textarea = this.$refs.textareaRef
      if (textarea) {
        textarea.style.height = 'auto'
        this.$nextTick(() => {
          const height = `${
            Math.min(
              Math.max(this.minHeightPx, textarea.scrollHeight),
              this.maxHeightPx,
            ) + 6
          }px`
          textarea.style.height = height
          if (document.getElementById(this.wrapperId)?.style) {
            document.getElementById(this.wrapperId).style.height = height
          }
        })
      }
    },
    onInput(event) {
      this.$emit('update:modelValue', event.target.value)
      this.$nextTick(() => {
        this.adjustHeight()
      })
    },
  },
}
</script>

<style lang="scss">
.auto-height-textarea-wrapper {
  /* max-width: 500px; */
  margin: 0 auto;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  > .auto-height-textarea {
    width: 100%;
    resize: none;
    outline: none;
  }
}
</style>
